import React, { createContext, useContext, useState, useCallback } from 'react';
import {
  getVentas, updateEstado as apiUpdateEstado, updateNota as apiUpdateNota, updateEstadoYNota as apiUpdateEstadoYNota,
  getStock, addStockItem as apiAddStockItem, updateStockItem as apiUpdateStockItem, deleteStockItem as apiDeleteStockItem, uploadStockImage as apiUploadStockImage
} from '../api';

const DataContext = createContext();

export function DataProvider({ children }) {
  const [clientes, setClientes] = useState([]);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState(null);

  const cargarClientes = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getVentas();
      if (res.ok) setClientes(res.data || []);
      else setError(res.error || 'Error al cargar datos');
    } catch(e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const cambiarEstado = async (rowIndex, estado) => {
    await apiUpdateEstado(rowIndex, estado);
    setClientes(prev => prev.map(c =>
      c.rowIndex === rowIndex ? { ...c, estado } : c
    ));
  };

  const agregarNota = async (rowIndex, nota) => {
    await apiUpdateNota(rowIndex, nota);
    const ts = new Date().toLocaleString('es-MX', { timeZone: 'America/Mexico_City', hour12:false });
    setClientes(prev => prev.map(c => {
      if (c.rowIndex !== rowIndex) return c;
      const n = c.notas ? c.notas + '\n[' + ts + '] ' + nota : '[' + ts + '] ' + nota;
      return { ...c, notas: n };
    }));
  };

  const cambiarEstadoYNota = async (rowIndex, estado, nota) => {
    await apiUpdateEstadoYNota(rowIndex, estado, nota);
    const ts = new Date().toLocaleString('es-MX', { timeZone: 'America/Mexico_City', hour12:false });
    setClientes(prev => prev.map(c => {
      if (c.rowIndex !== rowIndex) return c;
      const n = nota ? (c.notas ? c.notas + '\n[' + ts + '] ' + nota : '[' + ts + '] ' + nota) : c.notas;
      return { ...c, estado: estado || c.estado, notas: n };
    }));
  };

  // ===== Inventario (STOCK) =====
  const [stock, setStock]               = useState([]);
  const [stockLoading, setStockLoading] = useState(false);
  const [stockError, setStockError]     = useState(null);

  const cargarStock = useCallback(async () => {
    setStockLoading(true);
    setStockError(null);
    try {
      const res = await getStock();
      if (res.ok) setStock(res.data || []);
      else setStockError(res.error || 'Error al cargar inventario');
    } catch(e) {
      setStockError(e.message);
    } finally {
      setStockLoading(false);
    }
  }, []);

  const crearStockItem = async (item) => {
    await apiAddStockItem(item);
    await cargarStock();
  };

  const editarStockItem = async (rowIndex, item) => {
    await apiUpdateStockItem(rowIndex, item);
    setStock(prev => prev.map(s => s.rowIndex === rowIndex ? { ...s, ...item } : s));
  };

  const eliminarStockItem = async (rowIndex) => {
    await apiDeleteStockItem(rowIndex);
    setStock(prev => prev.filter(s => s.rowIndex !== rowIndex));
  };

  const subirFotoStock = async (base64, filename, mimeType) => {
    const res = await apiUploadStockImage(base64, filename, mimeType);
    if (res && res.ok) return res.foto_url || res.url || '';
    throw new Error((res && res.error) || 'Error al subir imagen');
  };

  return (
    <DataContext.Provider value={{
      clientes, loading, error, cargarClientes, cambiarEstado, agregarNota, cambiarEstadoYNota,
      stock, stockLoading, stockError, cargarStock, crearStockItem, editarStockItem, eliminarStockItem, subirFotoStock
    }}>
      {children}
    </DataContext.Provider>
  );
}
export const useData = () => useContext(DataContext);
